<template>
  <div class="home">
    <vue-headful
      title="Happy Zürich - Become active"
  />
    <Start msg=""/>
    <footer>Made with 🖤 by  <a href="https://marcoluthi.com" target="_blank">Marco Luthi</a> for <a href="https://www.designathon.ch/" target="_blank">Designathon18</a>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Start from '@/components/Start.vue'

export default {
  name: 'home',
  components: {
    Start
  }
}
</script>

//TODO
//Add Auth function
//Save un verified Users Cookie.
